import { FC } from 'react';
import ToggleSection from 'components/ToggleSection/ToggleSection';

interface PmsScheduleToggleSectionProps {
  control: any;
}

const PmsScheduleToggleSection: FC<PmsScheduleToggleSectionProps> = ({
  control,
}) => {
  return (
    <ToggleSection
      control={control}
      name="isPmsBlockSchedulingPrioritizedEnabled"
      title="Follow Blockout Availability"
      tooltip={
        <span className="flex flex-col gap-y-0.8">
          <span>
            <span className="font-bold">
              Blockouts don't follow PMS schedules:
            </span>{' '}
            For dates not synced from your PMS, FirstIn uses its own schedule.
            If the FirstIn schedule is set to “off” for that date, no slots are
            shown.
          </span>
          <span>
            <span className="font-bold">Blockouts follow PMS schedules:</span>{' '}
            Dates not synced from your PMS show no availability, and only
            blockout times are shown as open slots.
          </span>
        </span>
      }
    />
  );
};

export default PmsScheduleToggleSection;
